import { Box } from "@mui/material";
import { OverlaySlot } from "../../../components/Wrappers/OverlaySlot";
import { useThemeContext } from "../../../globalContext/global-context";
import type { CompletionLayout } from "../../CompletionControl";

export const ChatCompletionLayout: CompletionLayout = ({
  message,
  actions,
}) => {
  const { globalObject } = useThemeContext();
  const theme = globalObject.themeData.normalizedTheme;
  return (
    <OverlaySlot
      open
      ariaLabelledBy="completion-title"
      testId="completion-overlay"
    >
      <Box
        data-testid="session-control-complete"
        sx={{ padding: `${theme.tokens.spacing["4"]}px`, textAlign: "center" }}
      >
        {message}
        <Box sx={{ marginTop: `${theme.tokens.spacing["4"]}px` }}>
          {actions}
        </Box>
      </Box>
    </OverlaySlot>
  );
};
